(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitalisco-immersive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-vitalisco-video]');
    sections.forEach((section) => {
      const nav = section.querySelector('[data-vr-nav]');
      const revealItems = section.querySelectorAll('[data-vr-reveal]');
      const stageWrap = section.querySelector('[data-vr-stage-wrap]');
      const stage = section.querySelector('[data-vr-stage]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const reveal = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            reveal.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach((item) => reveal.observe(item));

      const updateScroll = () => {
        if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 24);
        if (stageWrap && stage && !reducedMotion) {
          const rect = stageWrap.getBoundingClientRect();
          const centerDistance = (window.innerHeight / 2 - rect.top - rect.height / 2) / window.innerHeight;
          const progress = Math.max(-1, Math.min(1, centerDistance));
          const scale = 1.035 - Math.abs(progress) * 0.08;
          stage.style.setProperty('--stage-y', (progress * -24) + 'px');
          stage.style.setProperty('--stage-scale', scale.toFixed(3));
        }
      };
      if (stage && !reducedMotion) {
        stage.addEventListener('pointermove', (event) => {
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;
          stage.style.setProperty('--stage-rx', (y * -7) + 'deg');
          stage.style.setProperty('--stage-ry', (x * 7) + 'deg');
        });
        stage.addEventListener('pointerleave', () => {
          stage.style.setProperty('--stage-rx', '0deg');
          stage.style.setProperty('--stage-ry', '0deg');
        });
      }
      updateScroll();
      window.addEventListener('scroll', updateScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
